import { el } from '../../core/dom.js';
import { syncNowButton } from '../../components/sync-now.js';
import {
  depthParts, healthLabel, isLive, latencyWidth, liveSubtitle, liveTitle,
} from './catalogue.js';
import { cxMark } from './mark.js';

function depthBar(parts) {
  return el('div', { class: 'cx-depth-bar grow', 'aria-hidden': 'true' },
    parts.map((part) => el('span', {
      class: part.filled ? `cx-seg is-${part.key}` : 'cx-seg is-open',
      style: `flex:${part.weight}`,
    })));
}

export function renderDepth(depth, failed, onRetry) {
  if (failed) {
    return el('section', { class: 'cx-card cx-depth', 'aria-label': 'Analysis depth' },
      el('p', { class: 'cx-copy' }, failed),
      el('button', { type: 'button', class: 'cx-btn', onClick: onRetry }, 'Try again'));
  }
  const score = Number(depth && depth.analysis_depth) || 0;
  const parts = depthParts(depth && depth.depth_breakdown);
  return el('section', { class: 'cx-card cx-depth lift rv', 'aria-label': 'Analysis depth' },
    el('div', { class: 'cx-depth-top' },
      el('span', { class: 'cx-kicker' }, 'Analysis depth'),
      el('span', { class: 'cx-depth-score' }, String(score), el('em', {}, '%'))),
    depthBar(parts),
    el('div', { class: 'cx-depth-legend' },
      parts.map((part) => el('span', { class: part.filled ? '' : 'is-open' }, part.text))));
}

function liveCard(row, index, admin) {
  const title = liveTitle(row);
  const live = isLive(row);
  const ms = Number(row.latency_ms);
  const shown = Number.isFinite(ms) && ms >= 0 ? String(ms) : '—';
  return el('article', {
    class: `cx-card cx-live-card lift rv${live ? ' is-live' : ''}`,
    style: `animation-delay:${(0.12 + index * 0.06).toFixed(2)}s`,
  },
  el('div', { class: 'cx-live-top' },
    cxMark(row.provider_name || row.provider_display || title, title, { inverted: true }),
    el('span', { class: 'cx-live-name' },
      el('span', { class: 'cx-name' }, title),
      el('span', { class: 'cx-sub' }, liveSubtitle(row))),
    el('span', { class: live ? 'cx-pill is-live' : 'cx-pill' },
      live ? el('span', { class: 'cx-ping', 'aria-hidden': 'true' }) : null,
      healthLabel(row))),
  el('div', { class: 'cx-meter' },
    el('span', { class: 'cx-track' },
      el('span', { class: 'cx-fill grow', style: `width:${latencyWidth(row.latency_ms)}` })),
    el('span', { class: 'cx-ms' }, `${shown} ms`)),
  admin && row.mode === 'synced' && row.source_id
    ? syncNowButton(row.source_id, 'btn btn-ghost cx-sync')
    : null);
}

export function renderLiveGrid(rows, opts = {}) {
  if (!rows.length) {
    return el('article', { class: 'cx-card cx-live-empty' },
      el('p', { class: 'cx-kicker' }, 'Sources'),
      el('p', { class: 'cx-copy' }, 'No sources connected yet. Pick one from the catalogue below.'));
  }
  return rows.map((row, index) => liveCard(row, index, !!opts.admin));
}
